import {Injectable} from "@angular/core";
import {ApiService} from "../../../shared/services/api.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {applicationUrls} from "../../../shared/application-constants/application-urls.const";

@Injectable({
  providedIn: 'root'
})
export class AdminsDashboardService{



  constructor(private apiService: ApiService, private http: HttpClient,
  ) {

  }


  getAdminsDashboardDetails(userId: any): Observable<any> {
    const url = `${applicationUrls.commonService.adminsDashboardDetails}/`+userId;
    return this.apiService.get(url);
  }


  getAssessmentDates(id: number | undefined) {
    const url = `${applicationUrls.commonService.getAssessmentDates}/`+id;
    return this.apiService.get(url);
  }

  getStpCounts() {
    const url = `${applicationUrls.applications.getStpCounts}`;
    return this.apiService.get(url);
  }
}
